import { FeatureMouseInteraction } from '@openlayers/interaction/FeatureMouseInteraction';
import { setMapCursor } from '@openlayers/ol-utils';
import { VehiclesLayer } from '@openlayers/vehicles/VehiclesLayer';
import { mapRootStore, mapUI, mapWrapper } from '@pages/map/map';
import { WindowManager } from '@shared/ui-react/FloatingWindow';
import { VehicleInfoCard } from '@shared/vehicles/ui/VehicleInfoCard';
import Feature from 'ol/Feature';
import * as React from 'react';


/**
 * @author NikolaV
 */
export class VehicleDesktopMouseInteraction extends FeatureMouseInteraction<VehiclesLayer> {
    private openVehicle: IVehicle; // we do nothing when clicking on already clicked/opened vehicle

    onClick = (feature: Feature, e, n): void => {
        const vehicle = feature.get('data');
        if (this.openVehicle && vehicle.id === this.openVehicle.id) return;
        this.openVehicle = vehicle;

        WindowManager.open({
            group: 'vehicle-info-card',
            id: vehicle.id,
            showCloseButton: true,
            allowMultiple: true,
            resize: 'both',
            defaultSizing: {
                width: 430,
                height: 300
            },
            collapsedTitle: vehicle.name,
            onClose: this.onWindowClosed,
            body: <div style={{ padding: '0 10px 10px', overflow: 'auto' }}>
                <VehicleInfoCard
                    vehicle={vehicle}
                    mapWrapper={mapWrapper}
                    treeData={mapRootStore.treeData}
                    onLoadActiveModel={id => mapUI.mapPanels.panels.models.checkIds([id])}
                    onModelShowInTree={id => mapUI.mapPanels.panels.models.focusItem(id)}
                    onModelShowInFilesPage={id => {
                        const treeNode = mapUI.mapPanels.panels.models.tree.getById(id);
                        if (treeNode) {
                            window.open(kuura.getContextPath() + '/models.htm#/' + treeNode.parent.id + '/' + id, '_blank');
                        }
                    }}
                    onModelShowIn3dPage={id => window.open(kuura.getContextPath() + '/mapvisualization.htm?modelId=' + id, '_blank')}
                />
            </div>
        });
    };

    onMouseOver = (feature: Feature) => {
        setMapCursor(this.layerWrapper.map, 'pointer');
    };

    onWindowClosed = () => {
        this.openVehicle = null;
    };
}
